export const getAuthTokens = () => {
  const localStorageAuthRaw = window.localStorage.getItem('auth');
  const localStorageAuth = localStorageAuthRaw ? JSON.parse(localStorageAuthRaw) : null;
  return localStorageAuth;
};
